import { render } from "./SupplierSearch.vue?vue&type=template&id=4f0356b9&scoped=true"
import script from "./SupplierSearch.vue?vue&type=script&lang=js"
export * from "./SupplierSearch.vue?vue&type=script&lang=js"

import "./SupplierSearch.vue?vue&type=style&index=0&id=4f0356b9&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f0356b9"]])

export default __exports__